export const upgradeModalHeaders = {
  customSurveys: `Upgrade now and gain access to unlimited Soono Survey templates.`,
  users: 'Upgrade now and add unlimited users',
  addons: `Upgrade now and grow your business with Growth Add-Ons.`,
  exportEmails: `Export unlimited email addresses when you upgrade to Pro.`,
};

export const upgradeModalSubHeaders = {
  customSurveys: `When you upgrade your plan, you will gain access to advanced features,
  Growth Add-Ons support, unlimited users, surveys, and reports, and much more.`,

  users: `When you upgrade your plan, you will gain access to advanced features,
  Growth Add-Ons support, unlimited users, surveys, and reports, and much more.`,

  addons: `When you upgrade your plan, you will gain access to advanced features,
  Growth Add-Ons support, unlimited users, surveys, and reports, and much more.`,

  exportEmails: `When you upgrade your plan, you will gain access to advanced features,
  Growth Add-Ons support, unlimited users, surveys, and reports, and much more.`,
};



// WEBPACK FOOTER //
// ./src/constants/upgradeSubscription.js